module.exports = __webpack_public_path__ + "img/hook_PEWAG_LHW_4.e9f92f55.png";